import {gql} from "@apollo/client";
import {client} from "graphql/client";

// 创建总部管理员
export const CREATE_ACCOUNT_HEADQUARTERS_ADMIN = gql`
    mutation CreateAccountHeadquartersAdmin($input: AccountHeadquartersStaffInput!) {
        createAccountHeadquartersAdmin(input: $input)
    }
`;

// 更新总部管理员
export const UPDATE_ACCOUNT_HEADQUARTERS_ADMIN = gql`
    mutation UpdateAccountHeadquartersAdmin($input: AccountHeadquartersStaffInput!) {
        updateAccountHeadquartersAdmin(input: $input)
    }
`;

export interface AccountHeadquartersAdminInput {
    id?: string;
    email?: string;
    countryCode: number;
    phone?: string;
    password?: string;
    name: string;
    avatarStorageToken?: string;
    status: number;
}

export const createAccountHeadquartersAdmin = async (input: AccountHeadquartersAdminInput): Promise<boolean> => {
    const {data} = await client.mutate({
        mutation: CREATE_ACCOUNT_HEADQUARTERS_ADMIN,
        variables: {input}
    });
    return data.createAccountHeadquartersAdmin;
};

export const updateAccountHeadquartersAdmin = async (input: AccountHeadquartersAdminInput): Promise<boolean> => {
    const {data} = await client.mutate({
        mutation: UPDATE_ACCOUNT_HEADQUARTERS_ADMIN,
        variables: {input}
    });
    return data.updateAccountHeadquartersAdmin;
};

